/**
 * Styled Components - Created by cazarez on 27/02/18.
 */
import styled from 'styled-components'
import icon from 'antd/lib/icon'
import MenuAntd from 'antd/lib/menu'
import Popover from 'antd/lib/popover'
import {
  RED,
  GRAY_LIGHTEST,
  WHITE,
  BLUE,
  GRAY_DARK
} from '../../theme/colors'

const { SubMenu } = MenuAntd
interface DivProps {
  withBorder?: boolean
  bold?: boolean
}

export const Container = styled.div`
  align-items: center;
  display: flex;
  color: ${WHITE};
`

export const Text = styled.div`
  color: #FFFFFF;
  cursor: pointer;
  font-size: 12px;
  font-family: var(--font-barlow);
  z-index: 7;
  margin-left: 6px;
  letter-spacing: 1.12px;
  @media (max-width: 1099px) {
    align-items: center;
    display: flex;
    font-weight: 600;
    height: 40px;
    margin: 2px 0;
  }
`

export const Icon = styled(icon)`
  color: ${RED};
  margin-right: 4px;
  font-size: 15px;
  font-weight: 600;
`

export const PopoverStyled = styled(Popover)``

export const Item = styled(MenuAntd.Item)`
  width: 100%;
  padding: ${({ withBorder, bold }: DivProps) => withBorder || bold ? `0 6px !important` : '0 18px !important'};
  font-weight: ${({ bold }: DivProps) => bold ? `bold` : 'normal'};
  text-transform: ${({ withBorder, bold }: DivProps) => withBorder || bold ? `uppercase` : 'capitalize'};
  border-bottom: ${({ withBorder }: DivProps) => withBorder ? `1px solid ${GRAY_LIGHTEST}` : 'none'};
`

export const TitleItem = styled(MenuAntd.Item)`
  width: 100%;
  padding: 0 6px !important;
  text-align: center;
  font-weight: bold;
  font-size: 14px !important;
  text-transform: uppercase;
  border-bottom: 1px solid ${GRAY_LIGHTEST};
  height: auto !important;
  &.ant-menu-item-active .managerClass {
    color: ${GRAY_DARK};
  }
`

export const ManagerSection = styled.div`
  width: 100%;
  font-weight: normal;
  text-transform: none;
  line-height: normal;
  text-align: left;
  margin-top: 4px;
  margin-bottom: 10px;
  font-size: 12px;
`

export const ManagerDiv = styled.div`
  display: flex;
  margin-bottom: 6px;
  flex-wrap: wrap;
`

export const ManagerValue = styled.div`
  font-weight: bold;
  font-family: Avenir;
  margin-left: 6px;
  color: ${GRAY_DARK};
`

export const ManagerDirect = styled.div``

export const PhoneManager = styled.a`
  color: ${BLUE};
  font-weight: bold;
  font-family: Avenir;
  margin-left: 6px;
`

export const EmailManager = styled.a`
  color: ${BLUE};
  margin-left: 6px;
`

export const EmailDiv = styled.div`
  width: 100%;
  margin-top: 2px;
`

export const UserIcon = styled(Icon)``

export const StyledSubMenu = styled(SubMenu)`
  border-bottom: 1px solid ${GRAY_LIGHTEST};
  .ant-menu-submenu-title {
    padding: 0 2px 0 6px !important;
    width: 100%;
  }
  .ant-menu-submenu-arrow {
    right: 12px;
  }
`

export const MenuTitle = styled.div``

export const BetaLabel = styled.div`
  display: inline-block;
  font-size: 8px;
  color: #40ab6d;
  font-style: italic;
  margin-left: 4px;
  vertical-align: top;
  margin-top: -3px;
  font-weight: bold;
`

export const NewLabel = styled.div`
  display: inline-block;
  font-size: 8px;
  color: ${RED};
  font-style: italic;
  margin-left: 4px;
  vertical-align: top;
  margin-top: -3px;
  font-weight: bold;
`

export const RightIcon = styled(icon)`
  flex: 1;
  text-align: right;
  padding-right: 16px;
  font-size: 12px;
  color: ${RED};
`

export const LeftIcon = styled(icon)`
  padding: 0 28px 0 8px;
  font-size: 12px;
  color: ${RED};
`

export const ResellerTag = styled.img`
  max-width: 56px;
  margin-left: 8px;
  border-radius: 3px;
  opacity: 0.7;
  margin-top: 4px;
`

export const menuStyle = { width: '100%' }

export const overStyle = {
  maxWidth: '292px',
  width: '100%',
  zIndex: 1000
}

export const OverviewStyle = { border: 'none' }

export const titleStyle = {
  marginBottom: 0
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/Logout/styledComponents.tsx